import { Invoice } from '@kinet-open-network/client/invoices/data-access';
import { IInvoiceStatus } from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';

export class InvoiceStatus implements IInvoiceStatus {
  @Type(() => Invoice)
  invoices!: Invoice[];
  totalUnliquidatedAmount!: number;
  canLiquidateAmount!: number;
  processingPaymentsAmount!: number;

  constructor(data: Partial<InvoiceStatus>) {
    Object.assign(this, data);
  }
}
